<template>
  <div class="banner-box">
    <el-carousel height="316px">
      <el-carousel-item v-for="(item, index) in list" :key="index">
        <el-image
          class="banner-image"
          :src="item.img_show"
          mode="scaleToFill"
        />
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
import { getPicList } from '@/api/pic'
export default {
  props: {
    images: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data() {
    return {
      list: []
    }
  },
  created() {
    this._getList()
  },
  methods: {
    _getList() {
      getPicList({cid: 3}).then(res => {
        if (res.code === 200 && res.data) {
          this.list = res.data
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.banner-box {
  width: 900px;
  .banner-image {
    width: 900px;
    height: 316px;
  }
}

</style>